import React from 'react';
import ChecklistGrid from './ChecklistGrid';

export default function Checklist() {
  return <ChecklistGrid />;
}
